import { DANGER_COLOR, DEFAULT_BG_COLOR, WARNING_COLOR } from 'shared/consts';
import styled, { css } from 'styled-components';
import { BasicCircleButtonVariant } from './types';
import {
	DARK_TEXT_COLOR,
	INFO_COLOR,
	MAIN_COLOR,
	MAIN_TEXT_COLOR,
	TEXT_COLOR,
} from 'shared/consts/styleValues';

interface ButtonProps {
	$variant?: BasicCircleButtonVariant;
	$redBorder?: boolean;
}

const getVariantStyles = (variant?: BasicCircleButtonVariant) => {
	switch (variant) {
		case 'danger':
			return {
				background: DANGER_COLOR,
				color: DARK_TEXT_COLOR,
			};
		case 'warning':
			return {
				background: WARNING_COLOR,
				color: TEXT_COLOR,
			};
		case 'info':
			return {
				background: INFO_COLOR,
				color: TEXT_COLOR,
			};
		case 'light-danger':
			return {
				background: DEFAULT_BG_COLOR,
				color: DANGER_COLOR,
			};
		case 'light-warning':
			return {
				background: DEFAULT_BG_COLOR,
				color: WARNING_COLOR,
			};
		default:
			return {
				background: DEFAULT_BG_COLOR,
				color: MAIN_TEXT_COLOR,
			};
	}
};

export const Button = styled.div<ButtonProps>`
	height: fit-content;
	padding: 3px 2.5px;
  min-width: 26px;
	box-sizing: border-box;
	border-radius: calc(1px / 0);
	background: ${props => getVariantStyles(props.$variant).background};
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 12px;
	line-height: 1;
	color: ${props => getVariantStyles(props.$variant).color};
	border-width: 1px;
	border-style: solid;
	border-color: ${props => props.$variant === 'default' ? MAIN_COLOR : 'transparent'};
	font-weight: 600;
	${props => props.$redBorder && css`border: 2px solid ${DANGER_COLOR}`};
	cursor: ${props => (props.onClick ? 'pointer' : 'default')};
`;
